/*
 * @Author: your name
 * @Date: 2021-08-23 14:25:37
 * @LastEditTime: 2021-09-02 14:01:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /qlchat-apollo-frontend-seo/pages/pc-client/components/Layout/LayoutHead.tsx
 */
import React from 'react';
import { connect } from 'react-redux';
import Picture from '../../../../components/picture/Picture';

/** props */
interface IProps {
	categoryList?: any;
	topicListEl?: any;
	region?: string;
	activeTab?: string;
}

/**
 * 页眉
 */
class LayoutHead extends React.PureComponent<IProps> {
	/**
	 * render
	 */
	public render(): any {
		const { categoryList, activeTab } = this.props;

		return (
			<div className="p-layout-head">
				<div className="wrap">
					<a href="/">
						<img src="https://img.qlchat.com/qlLive/activity/image/IA73ZDCR-6CAM-TR6K-1630562119655-VG8XMK9MJG7C.png" className="ql-logo" alt="" />
					</a>
					<div className="p-layout-head-tab-link">
						<a className={activeTab === 'training' ? 'active' : ''} href={'/'}>
							千聊特训营
						</a>
						<a className={activeTab === 'home' ? 'active' : ''} href={'/frontend/home'}>
							千聊小课
						</a>
					</div>
					{activeTab === 'home' && (
						<div className="button-box">
							<div className="ql-class">
								课程分类
								<ul className="ql-class-float float-menu">
									{categoryList.first.map((item: any, idx: number): any => (
										<li key={idx}>
											<a href={`/frontend/tags/${item.id}/0/p1/`}>{item.name}</a>
											<ul className="ql-class-float-sub float-menu">
												<li>
													<a href={`/frontend/tags/${item.id}/0/p1/`}>精选</a>
												</li>
												{categoryList.second[item.id] && categoryList.second[item.id].length > 0
													? categoryList.second[item.id].map((subItem: any, subIdx: number): any => (
															<li key={subIdx}>
																<a href={`/frontend/tags/${item.id}/${subItem.id}/p1/`}>{subItem.name}</a>
															</li>
													  ))
													: null}
											</ul>
										</li>
									))}
								</ul>
							</div>
							<a href="/frontend/app-download" className="p-button-primary download-btn">
								下载客户端
								<div className="qr-code-box">
									<img src="https://img.qlchat.com/qlLive/activity/image/C1W3V3GI-TVLB-JOET-1604901796523-4ARIZLEG7K4W.png" alt="" />
									<p>扫码下载APP</p>
								</div>
							</a>
							<a href="https://m.qlchat.com/wechat/page/create-live?ch=create-live_qlpc_homepage&wcl=seo" className="p-button-dashed ext on-log" data-log-region={this.props.region || 'create-live-btn'}>
								我也要开课
							</a>
							<a href="https://m.qlchat.com/wechat/page/recommend?wcl=seo">
								<Picture placeholder src="https://img.qlchat.com/qlLive/activity/image/O5BC5657-9MGE-ZIZL-1605063456874-SCTPBFBMU1EF.png" className="ql-user-poster" />
							</a>
						</div>
					)}
				</div>
			</div>
		);
	}
}

/**
 * mapStateToProps
 */
function mapStateToProps(state: any): any {
	return {
		categoryList: state.common.categoryList,
	};
}

const mapActionToProps: any = {};

export default connect(mapStateToProps, mapActionToProps)(LayoutHead);
